import React from 'react';
import PropTypes from 'prop-types';

const SVG = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" className={props.className}>
    <g fill="none" fillRule="evenodd" stroke="#B5B4B8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(1 1)">
      <path d="M11.5 3.5h4M.5 3.5h2M4.5 12.5h-4M15.5 12.5h-2" />
      <circle cx="5.5" cy="3.5" r="3" />
      <circle cx="10.5" cy="12.5" r="3" />
    </g>
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
};

export default SVG;
